module.exports = __webpack_public_path__ + "img/project-3.648ad9bf.png";